import { riskManagement } from 'constants/risk-management';
import { useGlobals } from 'hooks/useGlobals';
import { useTruckerNavigation } from 'hooks/useNavigation';
import { useMemo } from 'react';

export const useRiskManagement = () => {
  const { features, user } = useGlobals();

  const { handleNavigation } = useTruckerNavigation();

  const makeNavigateToRiskMagementURL = (truckerId: string, freightId?: string, partnerName?: string) => {
    const freightIdParam = freightId ? `&frete=${freightId}` : '';
    const partnerParam = partnerName ? `&partner=${partnerName}` : '';

    return `${riskManagement.redirect}?motorista=${truckerId}${freightIdParam}${partnerParam}`;
  };

  const navigateToRiskManagement = (truckerId: string, freightId?: string, partnerName?: string) =>
    handleNavigation(makeNavigateToRiskMagementURL(truckerId, freightId, partnerName));

  const comboName = user?.data?.company?.combo?.name;
  const isBeginnerPlan = comboName === 'Iniciante' || comboName === 'Iniciante Antigo';
  const hasAccessByFeatureFlag = useMemo(
    () => !!features?.data?.some(({ feature }: { feature: string }) => feature === riskManagement.feature),
    [features]
  );
  const hasRiskManagementAccess = (isBeginnerPlan && hasAccessByFeatureFlag) || !isBeginnerPlan;

  return {
    navigateToRiskManagement,
    makeNavigateToRiskMagementURL,
    riskManagamentButtonIsVisible: hasRiskManagementAccess,
  };
};
